import type { SaleOnboardingProgress } from '../../types'
import {
  stepCompleteForOnboarding,
  TAB_BY_ONBOARDING_STEP,
  type SaleOnboardingStepKey,
} from './SaleOnboardingStepper'

export type SaleLifecyclePhaseKey =
  | 'payment'
  | 'documentation'
  | 'commissions'
  | 'invoicing'
  | 'ready_for_preparation'
  | 'quality_control'
  | 'ready_for_delivery'

export const SALE_LIFECYCLE_PHASE_ORDER: SaleLifecyclePhaseKey[] = [
  'payment',
  'documentation',
  'commissions',
  'invoicing',
  'ready_for_preparation',
  'quality_control',
  'ready_for_delivery',
]

export const LIFECYCLE_PHASE_TO_ONBOARDING_STEP: Record<
  SaleLifecyclePhaseKey,
  SaleOnboardingStepKey | null
> = {
  payment: 'payment',
  documentation: 'documentation',
  commissions: 'commissions',
  invoicing: 'invoicing',
  ready_for_preparation: 'pipeline',
  quality_control: null,
  ready_for_delivery: null,
}

export function getLifecyclePhaseTab(phase: SaleLifecyclePhaseKey): string | null {
  const sk = LIFECYCLE_PHASE_TO_ONBOARDING_STEP[phase]
  if (!sk) return null
  return TAB_BY_ONBOARDING_STEP[sk]
}

export function isLifecycleOnboardingPhaseComplete(
  phase: SaleLifecyclePhaseKey,
  progress: SaleOnboardingProgress
): boolean {
  const sk = LIFECYCLE_PHASE_TO_ONBOARDING_STEP[phase]
  if (!sk) return false
  return stepCompleteForOnboarding(progress, sk)
}
